import api from '@edu-fe/api'
import login from '@/utils/login'
import * as get from '@ccforeverd/tool-get'

export default class ShareMaker {
  constructor (target, href = window.location.href, pure = false) {
    this.target = target
    this.href = href
    this.pure = pure
    if (!window.wx) {
      return console.log('%cNot in weixin environment', { color: '#f00' })
    }
    this.wx = window.wx
    // this.wx.error(res => {
    //     this._init()
    // })
    this._define()
    // ios仅在页面初始化加载initShare android在每次router变化后重新init
    // 不在shareMaker中进行初始化定义 仅进行_define配置

    // this._init()
  }

  async _init () {
    const res = await api.payment.getWxConfig(window.localStorage.getItem('wkAppId'), encodeURIComponent(this.serialize()))
    await this._initWx(res.data)
    await this._define()
  }

  async _initWx (configs) {
    let jsonData = configs
    jsonData['jsApiList'] = ['chooseWXPay', 'onMenuShareTimeline', 'onMenuShareAppMessage', 'getLocalImgData', 'chooseImage']
    return new Promise(resolve => {
      wx.config({ ...jsonData })
      resolve()
      // wx.ready(() => resolve())
    })
  }

  async _define () {
    let settings = {}
    if (!this.pure) {
      const { userId, courseId, chapterId, courseImage, courseName, recommendWords, mediaType } = this.target
      const wpsSid = await login.getWpsSid()
      settings = {
        title: courseName || recommendWords,
        desc: recommendWords || courseName,
        imgUrl: courseImage,
        link: `https://course-m.auoktalk.com/share?type=${mediaType}&courseId=${courseId}&chapterId=${chapterId}&senderWpsSid=${wpsSid}&userId=${userId}`
      }
    } else {
      const { title, introduction, courseImage, imgUrl, link, success } = this.target
      settings = {
        title,
        link,
        desc: introduction,
        imgUrl: courseImage || imgUrl,
        success
      }
    }
    this._defineTimeline(settings)
    this._defineAppMessage(settings)

    this.wx.ready(() => {
      this._defineTimeline(settings)
      this._defineAppMessage(settings)
    })
  }

  _defineTimeline (set) {
    set.link = get.add(set.link, {

    })
    this.wx.onMenuShareTimeline(set)
  }

  _defineAppMessage (set) {
    set.link = get.add(set.link, {
      from: 'edu_share_message'
    })
    this.wx.onMenuShareAppMessage(set)
  }

  serialize () {
    return window.location.href.split('#')[0]
  }
}
